export default __webpack_public_path__ + "static/media/step12.544b6205.jpg";